import React, { useState } from 'react';
import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';
import Modal from 'antd/lib/modal';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';

// ICONS
import dropdownArrowGrey from '../../icons/dropdown-grey.svg';
import dropdownArrowLightGrey from '../../icons/dropdown-light-grey.svg';
import dropdownArrowBlue from '../../icons/dropdown-blue.svg';

import './CustomSnoozeModal.less';

export const CustomSnoozeModal = (props) => {
  const { onCancel, onSubmit, theme } = props;
  const [selectedDate, setSelectedDate] = useState(moment(moment(), 'MMM DD, YYYY'));
  const [selectedTime, setSelectedTime] = useState('09:00am');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const timesArray = [
    '09:00am',
    '09:30am',
    '10:00am',
    '10:30am',
    '11:00am',
    '11:30am',
    '12:00pm',
    '12:30pm',
    '1:00pm',
    '1:30pm',
    '2:00pm',
    '2:30pm',
    '3:00pm',
    '3:30pm',
    '4:00pm',
    '4:30pm',
    '5:00pm',
    '5:30pm',
    '6:00pm',
    '6:30pm',
    '7:00pm',
    '7:30pm',
    '8:00pm',
    '8:30pm',
    '9:00pm',
    '9:30pm',
    '10:00pm',
    '10:30pm',
    '11:00pm',
    '11:30pm',
    '12:00am',
    '12:30am',
    '1:00am',
    '1:30am',
    '2:00am',
    '2:30am',
    '3:00am',
    '3:30am',
    '4:00am',
    '4:30am',
    '5:00am',
    '5:30am',
    '6:00am',
    '6:30am',
    '7:00am',
    '7:30am',
    '8:00am',
    '8:30am',
  ];

  const timesItems = timesArray.map((time) => {
    return {
      key: time,
      label: (
        <div key={time} onClick={() => setSelectedTime(time)}>
          {time}
        </div>
      ),
    };
  });

  const disabledDate = (current) => {
    // Can not select days before current time
    return current && current < moment().startOf('day');
  };

  const submitCustomSnooze = () => {
    const date = moment(selectedDate).format('MMM DD, YYYY');
    const snoozedTime = moment(`${date} ${selectedTime}`, 'MMM D, YYYY (LT)');
    const durationInHours = moment.duration(snoozedTime.diff(moment())).asHours();

    if (durationInHours < 0) {
      setErrorMessage('You have selected a time in the past, please select a valid time in the future.');
    } else {
      onSubmit(durationInHours);
    }
  };

  const getDropdownIcon = () => {
    if (isDropdownOpen) {
      return <img className="dropdown-icon" src={dropdownArrowBlue} alt="dropdown" />;
    }
    return theme === 'light' ? (
      <img className="dropdown-icon" src={dropdownArrowGrey} alt="dropdown" />
    ) : (
      <img className="dropdown-icon" src={dropdownArrowLightGrey} alt="dropdown" />
    );
  };

  return (
    <Modal
      className={`alerts-overview-snooze-modal alerts-overview-snooze-modal-${theme}`}
      centered
      open
      keyboard
      title="Snooze alert until..."
      footer={null}
      onCancel={onCancel}
    >
      <div className="alerts-overview-snooze-modal__container">
        <span>Date</span>
        <DatePicker
          className="alerts-overview-snooze-modal__select"
          dropdownClassName="alerts-overview-snooze-modal__calendar"
          defaultValue={selectedDate}
          format="MMM DD, YYYY"
          disabledDate={disabledDate}
          onChange={(date) => setSelectedDate(date)}
          allowClear={false}
          showToday={false}
        />
      </div>
      <div className="alerts-overview-snooze-modal__container">
        <span>Time</span>
        <Dropdown
          className={`app-dropdown app-dropdown-${theme}`}
          trigger={['click']}
          onOpenChange={() => setIsDropdownOpen(!isDropdownOpen)}
          menu={{ items: timesItems }}
        >
          <div className="alerts-overview-snooze-modal__select">
            {selectedTime}
            {getDropdownIcon()}
          </div>
        </Dropdown>
      </div>
      <Button size="large" className="alerts-overview-snooze-modal__button" onClick={submitCustomSnooze}>
        <span className="alerts-overview-snooze-modal__button-text">Snooze</span>
      </Button>
      {errorMessage && <div className="alerts-overview-snooze-modal__error">{errorMessage}</div>}
    </Modal>
  );
};
